import React, { Component } from 'react';
import Input from '../Input/index';
import  Dropdown  from 'Components/Dropdown';

import styles from './styles.scss';
import { TAT_UNITS } from 'Constants/commonConstants';
import { formatToINR } from 'Utils/transform';
import ActionLoader from '../ActionLoader/index';
import Moment from 'moment';

export default class PostBidPopup extends Component {

    constructor(props) {
        super(props);
        const { biddingDetails } = this.props;
        this.state = {
            price: biddingDetails.price || '',
            tatValue: biddingDetails.tatValue || '',
            tatUnit: {
                unit: biddingDetails.tatUnit || 1,
                name: biddingDetails.tatUnitName || "Days"
            }
        };
        this.onChange = this.onChange.bind(this);
        this.onSelect = this.onSelect.bind(this);
    }

    componentDidMount() {
        const { biddingDetails, postBid, tripBids, fetchBids, tripId, linerId } = this.props;
        this.props.fetchBids(tripId, linerId);
    }

    onChange(e) {
        this.setState({[e.currentTarget.name]: e.currentTarget.value});
    }

    onSelect(value){
        this.setState({tatUnit: {
            unit: parseInt(value.value),
            name: value.name
        }});
    }

    postBid(e) {
        e.stopPropagation();
        this.props.postBid({
            price: this.state.price,
            tat: {
                ...this.state.tatUnit,
                value: this.state.tatValue
            }
        });
    }

    render() {
        const { biddingDetails, postBid, tripBids, fetchBids, tripId } = this.props;
        return (
            <div className="pa z-1 popup-container" >
                <div className="tLeft box-shadow bg-white br-5 pt-20 pl-20 pr-15 pb-15 z-1 ">
                    {
                        tripBids.dataFetching && <ActionLoader/>
                    }
                    {
                        !tripBids.dataFetching && <div className="flex flex-row mt-15">
                            <div className="flex-1 ">
                                <div className="section-sub-header-color fBold fs-14 mb-10 op-5">
                                    Bid History
                                </div>
                                <div className="ht-100 overflowAuto">
                                {
                                    tripBids.bids.map((bid, index) => {
                                        let price = (bid.price) ? bid.price : bid.counterPrice;
                                        return <div key={index} className="fs-12 section-sub-header-color  mb-10">
                                                <span>{index + 1}</span> 
                                                <span className="ml-10"> {formatToINR(price)} </span>
                                                <span className="ml-10"> {Moment(bid.created).format("DD MMM YYYY hh:mmA")} </span>
                                                <span className="ml-10">{bid.bidHistoryStatus}</span>
                                                {bid.remarks && <span className="ml-10">{bid.remarks}</span>}
                                            </div>
                                    })
                                }
                                </div>
                            </div>
                            <div className="ml-10">
                                <div className="section-sub-header-color fBold fs-14 mb-10 op-5">
                                    Bid Rules
                                </div>
                                <div className="ht-100 overflowAuto">
                                {
                                    tripBids.rules.map((rule, index) => {
                                        return <div key={index} className="fs-12 section-sub-header-color  mb-10">
                                                <span > { rule.name} </span>
                                            </div>
                                    })
                                }
                                </div>
                            </div>
                        </div>
                    }
                    
                </div>
            </div>
        )
    }
}
